import React from 'react';
import PropTypes from 'prop-types';

export default function RadioBtn({
  id,
  onChange,
  onClick,
  checked,
  disabled,
  label,
}) {
  return (
    <label className="radio-btn-form" htmlFor={`radio-${id}`}>
      <input
        id={`radio-${id}`}
        value={id}
        type="radio"
        onChange={onChange}
        onClick={onClick}
        checked={checked}
        disabled={disabled}
      />
      <span className="checkmark" />
      {label && <p>{label}</p>}
    </label>
  );
}

RadioBtn.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
};

RadioBtn.defaultProps = {
  onClick: () => {},
  onChange: () => {},
  disabled: false,
  label: null,
};
